import { SuggestionProps } from '@tiptap/suggestion';
import { useEffect } from 'react';
import { AskAiMenu } from './AskAiMenu';
import { CommandListMenu } from './CommandListMenu';
import { CreateEmbedMenu } from './CreateEmbedMenu';
import { MentionDocMenu } from './MentionDocMenu';
import { commandMenuState } from './store';
import type { CommandItemProps } from './types';

export const CommandsMenu = ({
  onClose,
  ...suggestion
}: SuggestionProps<CommandItemProps> & { onClose(): void }) => {
  const { currentMenu, changeMenu, reset } = commandMenuState();

  const backToCommands = (close?: boolean) => {
    changeMenu('commands', null);
    if (close) onClose();
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => () => reset(), []);

  if (currentMenu === 'embed') {
    return <CreateEmbedMenu onClose={backToCommands} suggestion={suggestion} />;
  }

  if (currentMenu === 'mentionDoc') {
    return <MentionDocMenu onClose={backToCommands} suggestion={suggestion} />;
  }

  if (currentMenu === 'askAi') {
    return (
      <AskAiMenu onClose={() => backToCommands(true)} suggestion={suggestion} />
    );
  }

  return <CommandListMenu onClose={onClose} suggestion={suggestion} />;
};
